import { ClientTeamMembership } from '../../../types/clientTeamMembership'
import { TeamCard } from './TeamCard'
import { LoadingSpinner } from '@homebotapp/hb-react-component-catalog'

interface TeamMemberCardProps {
  membership: ClientTeamMembership
  clientId: string
}

export const TeamMemberCard = ({ membership, clientId }: TeamMemberCardProps) => {
  const customerProfile = membership.customerProfile
  const isLoading = !membership
  const customerFullName = `${customerProfile.firstName} ${customerProfile.lastName}`
  const scheduleACallUri = membership.customerProfile.appointmentLinkUri
  if (isLoading) {
    return <LoadingSpinner />
  }

  return (
    <TeamCard
      clientTeamMembership={membership}
      teamMemberName={customerFullName}
      email={customerProfile.email}
      photoUri={customerProfile.photoUri}
      corporatePhotoUri={membership.corporateProfile.avatarUri}
      phone={customerProfile.phone}
      license={customerProfile.stateLicense}
      isVerified={membership.isVerified}
      clientId={clientId}
      title='Real Estate Agent'
      corporateProfileName={membership.corporateProfile.name}
      scheduleACallUri={scheduleACallUri}
    ></TeamCard>
  )
}
